<template>
  <div>
    <a-ext-check-box v-for="opt in options" :label="opt.name" v-model="opt.checked" width="120px" @change="onChange">

    </a-ext-check-box>
  </div>
</template>

<script>
import AExtCheckBox from './AExtCheckBox'
import mixin from '../mixin/AExtStringMixin'
import options from './LocalDic/MonitLink'
export default {
    name: "AExtMonitLinkCheckBox",
    mixins:[mixin],
    components:{AExtCheckBox},
    data(){
        return{
            localValue:'',
            options:[]//name,value,check
        }
    },
    created(){
        this.init()
    },
    methods:{
        init(){
            this.options=options;
            let checkedList=this.localValue.split(",");
            this.options.forEach(item=>{
                if(checkedList.contains(item.value))
                {
                    item.checked=true;
                }
                else {
                    item.checked=false;
                }
            });
        },
        onChange()
        {
            let checkedList=[];
            this.options.forEach(item=>{
               if(item.checked)
               {
                   checkedList.push(item.value)
               }
            });
            this.localValue=checkedList.join(',');
        }
    }
}
</script>

<style scoped>

</style>